"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareScore = exports.generateScoreChanged = exports.generateGameEnd = exports.generateGameState = exports.generateAnnouncements = void 0;
var tslib_1 = require("tslib");
var helper = tslib_1.__importStar(require("../common/template_helpers"));
var underscore_1 = tslib_1.__importDefault(require("underscore"));
var util_1 = require("../common/util");
var announcements_1 = require("../multi_sport_common/announcements");
function generateAnnouncements(state) {
    return {
        gameState: generateGameState(state.awayTeamId, state.homeTeamId, state.scores[state.awayTeamId], state.scores[state.homeTeamId], state.periodNumber, state.periodType),
        gameEnd: generateGameEnd(state),
        scoreChanged: generateScoreChanged(state),
    };
}
exports.generateAnnouncements = generateAnnouncements;
function generateGameState(awayId, homeId, awayScore, homeScore, periodNumber, periodType) {
    var awayTeam = helper.stubbify(awayId);
    var homeTeam = helper.stubbify(homeId);
    var periodFormatted = (0, announcements_1.formatPeriod)(periodNumber, periodType);
    return "We\u2019re underway at the ".concat(awayTeam, " game versus ").concat(homeTeam, ". Currently the game is in the ").concat(periodFormatted, " and the score is ").concat(awayTeam, " ").concat(awayScore, " ").concat(homeTeam, " ").concat(homeScore);
}
exports.generateGameState = generateGameState;
function generateGameEnd(state) {
    var scores = underscore_1.default.sortBy((0, exports.prepareScore)(state), function (t) { return -1 * t.score; });
    var leadingScore = scores[0];
    var trailingScore = scores[1];
    return leadingScore.score - trailingScore.score === 0
        ? "That's the end of the game, ".concat(leadingScore.stub, " and ").concat(trailingScore.stub, " tie ").concat(leadingScore.score, " to ").concat(trailingScore.score, ".")
        : "That's the end of the game, ".concat(leadingScore.stub, " get the win over ").concat(trailingScore.stub, " ").concat(leadingScore.score, " to ").concat(trailingScore.score, ".");
}
exports.generateGameEnd = generateGameEnd;
function generateScoreChanged(state) {
    var awayTeamScore = state.scores[state.awayTeamId];
    var homeTeamScore = state.scores[state.homeTeamId];
    return "Score changed! ".concat(awayTeamScore, " ").concat(homeTeamScore);
}
exports.generateScoreChanged = generateScoreChanged;
var prepareScore = function (state) {
    return (0, util_1.asTuple)([
        {
            stub: helper.stubbify(state.awayTeamId),
            score: state.scores[state.awayTeamId],
        },
        {
            stub: helper.stubbify(state.homeTeamId),
            score: state.scores[state.homeTeamId],
        },
    ]);
};
exports.prepareScore = prepareScore;
//# sourceMappingURL=announcements.js.map